import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from './auth.service';

const AUTHENTICATED_PREFIXES = ['/api', '/auth', '/backoffice'];

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  if (!AUTHENTICATED_PREFIXES.some(prefix => req.url.startsWith(prefix))) {
    return next(req);
  }

  const auth = inject(AuthService);
  const token = auth.getValidToken();

  // Pre-auth calls (login, verify-otp) have no token yet - let them through unmodified
  // rather than attaching an empty/invalid Authorization header.
  if (!token) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
